import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { DELETE_FACILITY_HOLIDAY, DELETE_FACILITY_HOLIDAY_SUCCESS, DELETE_FACILITY_HOLIDAY_ERROR } from '../../actions';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* deleteFacilityHoliday({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { holidayId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/golf-inventory/facility-holiday/${holidayId}`,
      method: 'PATCH',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message ?? 'Facility holiday deleted successfully'}`);
      yield put({
        type: DELETE_FACILITY_HOLIDAY_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: DELETE_FACILITY_HOLIDAY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DELETE_FACILITY_HOLIDAY_ERROR, payload: error });
  }
}

export function* watchDeleteFacilityHoliday() {
  yield takeEvery(DELETE_FACILITY_HOLIDAY, deleteFacilityHoliday);
}

function* deleteFacilityHolidaySaga() {
  yield all([fork(watchDeleteFacilityHoliday)]);
}

export default deleteFacilityHolidaySaga;
